import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-sidebar-button',
  templateUrl: './sidebar-button.component.html',
  styles: [
  ]
})
export class SidebarButtonComponent {

  constructor(@Inject(DOCUMENT) private document: any) {

  }

  toggle(): void {
    this.document.body.classList.toggle('sb-sidenav-toggled');
  }
}
